import {Component} from "@angular/core";
import {ActivatedRoute, Router} from "@angular/router";
import {WorkflowService} from "../workflow.service";
import {WorkflowStep} from "../workflow-step";
import {WorkflowTargetInfoModel} from "../models/workflow-target-info.model";
import {AssetService} from "../../asset/asset.service";
import {AssetStatus} from "../../asset/asset.types";
import {toggleLoading} from "../../misc/loading.decorator";
import {handleErrors} from "../../misc/handle-errors.decorator";

const DEFAULT_PAGE = 1;
const DEFAULT_PAGE_LIMIT = 10;

@Component({
  templateUrl: "./order-status-details.template.pug",
})
export class OrderStatusDetailsComponent extends WorkflowStep {
  assets: AssetStatus[];
  searchText: string = "";
  pageSize: number = DEFAULT_PAGE_LIMIT;
  currentPage: number = DEFAULT_PAGE;
  maxPages: number;
  totalCount: number = 0;
  filters = {
    Processing: false,
    Acknowledged: false,
    Production: false,
    ShippedToCustomer: false,
    Delivered: false,
    Cancelled: false,
  };

  constructor(
    public route: ActivatedRoute,
    public router: Router,
    public workflowService: WorkflowService,
    private assetService: AssetService,
  ) {
    super();
  }

  @toggleLoading()
  async ready(workflowTargetInfo: WorkflowTargetInfoModel) {
    if (!workflowTargetInfo.targetId) {
      return;
    }
    this.getAssets();
  }

  @handleErrors()
  async getAssets() {
    const {assets, pageLength, page, totalAssets} = await this.assetService.getAssetsStatutesByOrder(
      this.workflowService.workflowConfig.targetId,
      this.currentPage,
      this.pageSize,
      this.selectedFilters,
      this.searchText,
    );
    this.assets = assets;
    this.pageSize = pageLength;
    this.currentPage = page;
    this.totalCount = totalAssets;
    this.maxPages = Math.ceil(totalAssets / pageLength);
  }

  onListControlsChange(event) {
    switch (event["key"]) {
      case "page":
        this.currentPage = event["value"];
        break;
      case "search":
        this.currentPage = DEFAULT_PAGE;
        this.searchText = event["value"];
        break;
      case "limit":
        this.currentPage = DEFAULT_PAGE;
        this.pageSize = event["value"];
        break;
      case "filter":
        this.currentPage = DEFAULT_PAGE;
        break;
      default:
        console.info(`Unknown ${event["key"]}`);
        break;
    }
    this.getAssets();
  }

  get selectedFilters() {
    return Object.entries(this.filters)
      .filter(el => el[1])
      .map(el => el[0]);
  }
}
